import { Navigate, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function ProtectedRoute({ children, admin = false }) {
  const { user, ready } = useApp();
  const loc = useLocation();
  if (!ready)
    return <div className="min-h-screen grid place-items-center bg-asf-app text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
